export default __webpack_public_path__ + "static/media/x.25e4b3d1.svg";